import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import './Approach.css';

const oldWay = [
  'Rigid workflows forced onto teams that already had a system that worked',
  'Weeks of retraining just to make the tool fit the job',
  "Bundles of features you'll never touch, and gaps where you actually need help",
  'A platform that stays frozen while your business keeps changing',
];

const adap8Way = [
  'Solutions shaped around how your team already works, from day one',
  'Easy to use by design — your team is productive from week one',
  'End-to-end automation built for your exact operating model, nothing extra',
  'A system engineered to keep adapting as your business grows',
];

function Approach() {
  return (
    <section className="sec" id="approach">
      <div className="wrap">
        <ScrollReveal>
          <div className="sec-head">
            <div className="eyebrow">THE ADAP8 DIFFERENCE</div>
            <h2>
              Most software asks your team to adapt.{' '}
              We built ours to adapt to your team.
            </h2>
            <p>
              Off-the-shelf platforms make you reshape your business around their defaults.
              We start with how you actually operate — and build from there.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <div className="approach-grid">
            <div className="approach-col">
              <h3>The old way</h3>
              <ul>
                {oldWay.map((item, i) => (
                  <li key={i}>
                    <span className="mark no">✕</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="approach-col is-adap8">
              <h3>The adap8 way</h3>
              <ul>
                {adap8Way.map((item, i) => (
                  <li key={i}>
                    <span className="mark yes">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default Approach;
